import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // You can log the error to an error reporting service here
    // For now, just output to console for debugging
    // eslint-disable-next-line no-console
    console.error('Uncaught error in ErrorBoundary:', error, info);
  }

  handleReload = () => {
    // Force reload to recover from chunk load errors (common after HMR or deploy)
    try {
      window.location.reload();
    } catch (e) {
      // fallback
      window.location.href = '/';
    }
  };

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      const { error } = this.state;
      const isChunkError = error && (error.name === 'ChunkLoadError' || (error.message && error.message.includes('Loading chunk')));

      return (
        <div style={{ padding: 24, textAlign: 'center' }}>
          <h2>Something went wrong</h2>
          <p>{isChunkError ? 'A required script failed to load (maybe the dev server restarted or an update was deployed).' : 'An unexpected error occurred.'}</p>
          <p style={{ color: '#666', fontSize: 13 }}>{error?.message}</p>
          <div style={{ marginTop: 16 }}>
            <button onClick={this.handleReload} style={{ marginRight: 8, padding: '8px 12px' }}>Reload page</button>
            {!isChunkError && <button onClick={this.handleReset} style={{ padding: '8px 12px' }}>Try again</button>}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
